import React from 'react'
import {Map as LeafletMap, TileLayer} from 'react-leaflet';
import "./Map.css";
import {showDataOnMap} from './util'

function Map({countries,casesType,center,zoom}) {
    return (
        <div className="map">
        {/* before adding the map add react leaflet package npm i react-leaflet */}
        <LeafletMap center={center} zoom={zoom}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy;<a href="http://osm.org/copyright">OpenStreetMap</a> Contributors'
            />
            {/* loop through countries and draw cicles and more number bigger circles */}
            {showDataOnMap(countries,casesType)}
        </LeafletMap>
        </div>
    )
}

export default Map
